/**
 * Statisk indhold og billeder.
 *
 * BEMÆRK: Firmaoplysninger (navn, telefon, e-mail, CVR, adresse) ligger IKKE her.
 * De hentes fra Firestore-dokumentet settings/company, så der kun findes én kilde,
 * og de kan rettes af administratoren under Admin → Indstillinger.
 */
/**
 * Fast offentlig kontakt-e-mail. Kan IKKE ændres fra admin, og værdien i
 * settings/company ignoreres bevidst for det offentlige site.
 * Skrives altid med æ — aldrig punycode.
 */
export const CONTACT_EMAIL = 'kontakt@lykkeværk.dk'

export const company = {
  /** Stående logo — bruges stort på hvide flader. */
  logo: 'https://cdn.magicpatterns.com/uploads/nHxi4VXqzJoxJUMisTPGYE/image.png',
  /** Kvadratisk logomærke uden tekst — bruges som favicon og app-ikon. */
  logoMark: 'https://cdn.magicpatterns.com/uploads/hCqeATb4WBsqrVsZ6orgZg/LOGO_Uden_Skrift.png',
  /** Liggende logo med gennemsigtig baggrund — bruges i topbjælker. */
  logoWide: 'https://cdn.magicpatterns.com/uploads/eUzyTHyvYNvXG7KJGUf9oy/FIRMAgennemsigtig.png',
}

export interface Service {
  title: string
  description: string
  icon: 'wrench' | 'drill' | 'refresh'
}

export const services: Service[] = [
  {
    title: 'Multiservice',
    description: 'Praktiske opgaver, små reparationer og forskellige serviceopgaver.',
    icon: 'wrench',
  },
  {
    title: 'Montage',
    description: 'Montering og opsætning af inventar, udstyr og andre praktiske løsninger.',
    icon: 'drill',
  },
  {
    title: 'Vedligehold',
    description: 'Vedligeholdelse, reparation og løbende service.',
    icon: 'refresh',
  },
]

export const values = [
  {
    title: 'Ordentligt arbejde',
    description: 'Opgaven bliver lavet færdig, og der bliver ryddet op efter arbejdet.',
  },
  {
    title: 'Personlig kontakt',
    description: 'Du taler med den person, der udfører arbejdet — hele vejen.',
  },
  {
    title: 'Klare aftaler',
    description: 'Pris, omfang og tidspunkt er aftalt, inden vi går i gang.',
  },
]
